<template>
    <div class="nav__list" v-if="pages">
        <div class="nav__section">
            <template v-for="(page, index) in computedPages">
                <template v-if="isVisiblePage(page) && (isAuth && page.auth) || !page.auth">
                    <component class="nav__item" :key="index"
                        :class="{ 'nav__item--create-page': page.button && isUserTree(page) }"
                        :is="page.hasOwnProperty('to') ? 'router-link' : 'a'" v-bind="page" itemprop="url">
                        <svg v-if="iconPlusVisible(page)" width="11" height="11">
                            <use xlink:href="/assets/front/img/sprite.svg#icon-plus_nav"></use>
                        </svg>
                        <span class="nav__link" :class="{
                            'nav__link--active': page.href === $route.path,
                            'nav__last-child': isLastChild(page)
                        }">
                            <span v-if="isUserTree(page)"> {{ page.name }} </span>
                        </span>
                    </component>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
    name: 'HeaderPages',
    props: {
        render: false,
        pages: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            domain: window.laravel.appUrlByLocale,
            prefix: window.laravel.prefix,
            isAdmin: window.laravel.isAdmin,
            isPartner: window.laravel.isPartner,
            isMaster: window.laravel.isMaster,
        }
    },
    computed: {
        ...mapState('header', [
            'headerPages'
        ]),
        ...mapGetters('auth', [
            'isAuth'
        ]),
        isNotUser() {
            return this.isAdmin || this.isPartner || this.isMaster
        },
        computedPages() {
            return this.pages.map(page => {
                if (!page.hasOwnProperty('href')) return page;

                return {
                    ...page,
                    href: this.render
                        ? this.domain + this.prefix + page.href
                        : this.prefix + page.href
                };
            });
        },
    },
    methods: {
        isVisiblePage(page) {
            const hasAttr = Object(page).hasOwnProperty('visible');

            return hasAttr && page.visible || !hasAttr;
        },
        isUserTree(page) {
            return !(page.href === '/cabinet/tree' && (this.isAdmin || this.isPartner || this.isMaster))
        },
        isLastChild(page) {
            return page.href === '/memories#moments' && !this.isAuth || page.href === '/place#why' || page.href === '/contacts#support' || (page.href === '/familytree#faq' || page.href === '/cabinet/tree') && this.isNotUser
        },
        iconPlusVisible(page) {
            return page.href === '/create/tariffs' || page.href === '/cabinet/page/add'
        }
    }
}
</script>
